import React from 'react';
interface SectionTitleProps {
  children: React.ReactNode;
  light?: boolean;
  align?: 'center' | 'left';
}
export function SectionTitle({
  children,
  light = false,
  align = 'center'
}: SectionTitleProps) {
  return <div className={align === 'center' ? 'text-center' : ''} data-id="element-174" data-mp="3vw8odsuphf3k">
      <h2 className={`font-serif text-2xl font-bold uppercase leading-[1.1] tracking-wide sm:text-4xl ${light ? 'text-white' : 'text-brand-brown'}`} data-id="element-175" data-mp="4qh2x6rviqn3">
        {children}
      </h2>
      <span className={`mt-2 block h-0.5 w-14 bg-brand-gold ${align === 'center' ? 'mx-auto' : ''}`} data-id="element-176" data-mp="3qy76vccxhnu7" />
    </div>;
}